export default __webpack_public_path__ + "static/media/sliderCards_noThemeSelected.9edc1611.svg";